<template>
  <v-app>
    <v-container class="appclick">
      <Header>
        <font-awesome-icon :icon="['fas', 'diagnoses']" />
        <font-awesome-icon :icon="['fas', 'cogs']" />
        <router-link :to="{ name: 'settings_zones' }">
          <font-awesome-icon
            :icon="['fas', 'vector-square']"
            :style="{ color: 'green' }"
        /></router-link>

        <font-awesome-icon :icon="['fas', 'balance-scale']" />
        <span class="title">Movement zones: show loose ends</span>
      </Header>
      <v-row>
        <v-col class="col-6">
          <div id="map" class="map"></div>
          <pagination
            class="pagination col-xs-12"
            v-model="o_slider"
            :total-page="n_objects"
            boundary-links
            pills
            size="lg"
            @change="changeObject(o_slider)"
          />
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>
<script>
import ProjectService from "@/services/ProjectService.js";
import Header from "@/components/Header.vue";
import Map from "ol/Map";
import View from "ol/View";
import "ol/ol.css";
import { Vector as VectorSource } from "ol/source";
import ImageLayer from "ol/layer/Image";
import { Vector as VectorLayer } from "ol/layer";
import { Fill, Stroke, Style, Text } from "ol/style";
import GeoJSON from "ol/format/GeoJSON";
import Static from "ol/source/ImageStatic";
import Projection from "ol/proj/Projection";
import { getCenter } from "ol/extent";
var vectorsource;
var vectorsourcezones;
var vectorlayerzones;
var vectorlayer;
var image;
var extent = [0, 0, 720, 480];
var projection = new Projection({
  code: "static-image",
  units: "pixels",
  extent: extent
});
var style = new Style({
  fill: new Fill({
    color: "rgba(255, 0, 0, 0.1)"
  }),
  stroke: new Stroke({
    color: "#FF0000",
    width: 3
  }),
  text: new Text({
    font: "16px Calibri,sans-serif",
    fill: new Fill({
      color: "#000"
    }),
    stroke: new Stroke({
      color: "#fff",
      width: 2
    })
  })
});

export default {
  components: {
    Header
  },
  data: function() {
    return {
      objects: {},
      object: {},
      o_min: 0,
      n_objects: 0,
      o_slider: 1
    };
  },
  mounted() {
    this.ApiGet();
  },
  methods: {
    ApiGet() {
      ProjectService.apiGet({
        nid: this.$session.get("PROJID"),
        type: "settings_zones_test"
      })
        .then(response => {
          console.log(response);
          this.objects = response.data.objects.data.objects;
          this.n_objects = response.data.objects.data.n;
          this.zones = response.data.zones;
          vectorsource = new VectorSource({
            features: new GeoJSON().readFeatures(this.zones)
          });
          this.changeObject(1);
        })
        .catch(error => {
          console.log("Fout " + error.response);
        });
    },
    changeObject(nr) {
      var clearmap = document.getElementById("map");
      clearmap.innerHTML = "";
      this.object = this.objects[nr];
      vectorsource = new VectorSource({
        format: new GeoJSON(),
        url:
          "https://trafficdistillery.com/tracking/getmosaicgraph/" +
          this.$session.get("PROJID") +
          "/" +
          this.object.obj
      });
      vectorsourcezones = new VectorSource({
        features: new GeoJSON().readFeatures(this.zones)
      });
      vectorlayerzones = new VectorLayer({
        source: vectorsourcezones,
        style: styleFunction,
        name: "zones"
      });
      image = new ImageLayer({
        source: new Static({
          url:
            "https://trafficdistillery.com/sites/default/files/project/" +
            this.$session.get("PROJID") +
            "/images/" +
            this.object.frame +
            ".jpg",
          projection: projection,
          size: [720, 480],
          imageExtent: extent
        })
      });
      vectorlayer = new VectorLayer({
        source: vectorsource,
        style: function(feature) {
          style.getText().setText(feature.get("label"));
          return style;
        }
      });
      new Map({
        layers: [image, vectorlayer, vectorlayerzones],
        target: "map",
        controls: [],
        view: new View({
          projection: projection,
          center: getCenter(extent),
          zoom: 1.3,
          attribution: true
        })
      });
      function styleFunction(feature) {
        var att = feature.getProperties();
        return [
          new Style({
            fill: new Fill({
              color: "rgba(0, 255, 0, 0)"
            }),
            stroke: new Stroke({
              color: "#00ff00",
              width: 2
            }),
            text: new Text({
              font: "40px Calibri,sans-serif",
              fill: new Fill({ color: "#000" }),
              text: "" + att.id
            })
          })
        ];
      }
    }
  }
};
</script>
<style scoped>
.map {
  height: 420px;
  width: 630px;
}
</style>
